import React, { ReactNode } from 'react';
import cx from 'clsx';

import { IconRcLoading } from '@/assets';

import './index.css';

type Props = {
  size?: number;
  className?: string;
  children?: ReactNode;
  style?: React.CSSProperties;
};

export const Loading = ({ className, size = 20, children, style }: Props) => {
  return (
    <div className={cx('db-loading', className)} style={style}>
      <div className="db-loading-inner">
        <IconRcLoading width={size} height={size} className="db-loading-icon" />
        {children ? <div className="db-loading-child">{children}</div> : null}
      </div>
    </div>
  );
};

export default Loading;
